import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const LawyerSidebarNavigation = ({ isCollapsed = false, onToggleCollapse }) => {
  const location = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const navigationItems = [
    {
      title: 'داشبورد',
      path: '/lawyer-dashboard',
      icon: 'LayoutDashboard',
      description: 'نمای کلی و آمار'
    },
    {
      title: 'پروفایل',
      path: '/lawyer-profile-setup',
      icon: 'User',
      description: 'مدیریت پروفایل حرفه‌ای'
    },
    {
      title: 'مشاوره‌ها',
      path: '/consultations',
      icon: 'MessageSquare',
      description: 'مدیریت مشاوره‌های آنلاین'
    },
    {
      title: 'تقویم',
      path: '/calendar',
      icon: 'Calendar',
      description: 'برنامه‌ریزی قرارها'
    },
    {
      title: 'مالی',
      path: '/financial',
      icon: 'DollarSign',
      description: 'درآمد و تراکنش‌ها'
    }
  ];

  const secondaryItems = [
    {
      title: 'تنظیمات',
      path: '/settings',
      icon: 'Settings',
      description: 'تنظیمات حساب کاربری'
    },
    {
      title: 'پشتیبانی',
      path: '/support',
      icon: 'HelpCircle',
      description: 'راهنما و پشتیبانی'
    }
  ];

  const isActiveRoute = (path) => {
    return location?.pathname === path;
  };

  const handleUserMenuToggle = () => {
    setShowUserMenu(!showUserMenu);
  };

  const handleLogout = () => {
    console.log('Logout clicked');
    setShowUserMenu(false);
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className={`fixed right-0 top-0 z-[200] h-full bg-card border-l border-border transition-all duration-300 ${
        isCollapsed ? 'w-16' : 'w-64'
      } hidden lg:block`}>
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-border">
            {!isCollapsed && (
              <Link to="/lawyer-dashboard" className="flex items-center space-x-reverse space-x-3">
                <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
                  <Icon name="Scale" size={20} color="white" />
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-card-foreground">
                    ربات حقوقی
                  </span>
                  <span className="text-xs text-muted-foreground">
                    پنل وکیل
                  </span>
                </div>
              </Link>
            )}
            
            {onToggleCollapse && (
              <button
                onClick={onToggleCollapse}
                className="p-2 text-muted-foreground hover:text-card-foreground transition-smooth focus-ring rounded-md"
              >
                <Icon name={isCollapsed ? "ChevronLeft" : "ChevronRight"} size={20} />
              </button>
            )}
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4 space-y-2">
            {/* Primary Navigation */}
            <div className="space-y-1">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`flex items-center px-3 py-2 text-sm font-medium rounded-md transition-smooth focus-ring group ${
                    isActiveRoute(item?.path)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-card-foreground hover:bg-muted hover:text-card-foreground'
                  }`}
                  title={isCollapsed ? item?.title : ''}
                >
                  <Icon 
                    name={item?.icon} 
                    size={20} 
                    className={`${isCollapsed ? '' : 'ml-3'} flex-shrink-0`}
                  />
                  {!isCollapsed && (
                    <div className="flex flex-col">
                      <span>{item?.title}</span>
                      <span className="text-xs opacity-75">{item?.description}</span>
                    </div>
                  )}
                </Link>
              ))}
            </div>

            {/* Divider */}
            {!isCollapsed && <div className="border-t border-border my-4" />}

            {/* Secondary Navigation */}
            <div className="space-y-1">
              {secondaryItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`flex items-center px-3 py-2 text-sm font-medium rounded-md transition-smooth focus-ring group ${
                    isActiveRoute(item?.path)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-muted-foreground hover:bg-muted hover:text-card-foreground'
                  }`}
                  title={isCollapsed ? item?.title : ''}
                >
                  <Icon 
                    name={item?.icon} 
                    size={20} 
                    className={`${isCollapsed ? '' : 'ml-3'} flex-shrink-0`}
                  />
                  {!isCollapsed && (
                    <div className="flex flex-col">
                      <span>{item?.title}</span>
                      <span className="text-xs opacity-75">{item?.description}</span>
                    </div>
                  )}
                </Link>
              ))}
            </div>
          </nav>

          {/* User Profile */}
          <div className="p-4 border-t border-border">
            <div className="relative">
              <button
                onClick={handleUserMenuToggle}
                className={`flex items-center w-full px-3 py-2 text-sm font-medium text-card-foreground hover:bg-muted rounded-md transition-smooth focus-ring ${
                  isCollapsed ? 'justify-center' : ''
                }`}
              >
                <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="User" size={16} color="white" />
                </div>
                {!isCollapsed && (
                  <>
                    <div className="mr-3 flex-1 text-right">
                      <div className="text-sm font-medium">دکتر احمد محمدی</div>
                      <div className="text-xs text-muted-foreground">وکیل پایه یک</div>
                    </div>
                    <Icon name="ChevronUp" size={16} className="mr-2" />
                  </>
                )}
              </button>

              {/* User Dropdown */}
              {showUserMenu && (
                <div className={`absolute ${isCollapsed ? 'right-16' : 'right-0'} bottom-full mb-2 w-48 bg-popover border border-border rounded-md shadow-moderate z-50`}>
                  <div className="py-1">
                    <Link
                      to="/lawyer-profile-setup"
                      className="flex items-center w-full px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-smooth"
                      onClick={() => setShowUserMenu(false)}
                    >
                      <Icon name="User" size={16} className="ml-3" />
                      ویرایش پروفایل
                    </Link>
                    <Link
                      to="/settings"
                      className="flex items-center w-full px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-smooth"
                      onClick={() => setShowUserMenu(false)}
                    >
                      <Icon name="Settings" size={16} className="ml-3" />
                      تنظیمات
                    </Link>
                    <div className="border-t border-border my-1" />
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-2 text-sm text-destructive hover:bg-muted transition-smooth"
                    >
                      <Icon name="LogOut" size={16} className="ml-3" />
                      خروج از حساب
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </aside>
      {/* Mobile Bottom Navigation */}
      <nav className="fixed bottom-0 right-0 left-0 z-[200] bg-card border-t border-border lg:hidden">
        <div className="flex items-center justify-around py-2">
          {navigationItems?.slice(0, 4)?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`flex flex-col items-center px-3 py-2 text-xs font-medium transition-smooth focus-ring rounded-md ${
                isActiveRoute(item?.path)
                  ? 'text-primary' :'text-muted-foreground hover:text-card-foreground'
              }`}
            >
              <Icon name={item?.icon} size={20} className="mb-1" />
              <span>{item?.title}</span>
            </Link>
          ))}
          
          {/* More Menu for Mobile */}
          <button
            onClick={handleUserMenuToggle}
            className="flex flex-col items-center px-3 py-2 text-xs font-medium text-muted-foreground hover:text-card-foreground transition-smooth focus-ring rounded-md"
          >
            <Icon name="MoreHorizontal" size={20} className="mb-1" />
            <span>بیشتر</span>
          </button>
        </div>
      </nav>
      {/* Click outside to close user menu */}
      {showUserMenu && (
        <div 
          className="fixed inset-0 z-[190]" 
          onClick={() => setShowUserMenu(false)}
        />
      )}
    </>
  );
};

export default LawyerSidebarNavigation;